// Source/Cart-Items/Component.ts
class CartItems extends HTMLElement {
  controller;
  disconnectedCallback() {
    this.controller.abort();
  }
  connectedCallback() {
    this.controller = new AbortController;
    this.listen();
  }
  listen() {
    const { signal } = this.controller;
    const onQuantity = this.onQuantity.bind(this);
    for (const quantity of this.$quantities)
      quantity.addEventListener("change", onQuantity, { signal });
  }
  onQuantity(event) {
    const quantity = event.target;
    const before = Number(quantity.getAttribute("value")), after = Number(quantity.value);
    const delta = after - before;
    const row = quantity.closest(`tr`);
    const handle = row.dataset.productHandle, id = Number(row.dataset.variantId);
    const script = row.querySelector(`script[ type = 'application/json' ]`);
    const json = script.textContent;
    const data = JSON.parse(json);
    const code = data.Config_Code;
    if (delta > 0)
      Tracking.addItem({
        isOffer: false,
        code,
        payload: {
          quantity: delta,
          handle,
          id
        }
      });
  }
  get $quantities() {
    return this.querySelectorAll(`tbody tr .quantity-selector`);
  }
}

// Source/Cart-Items/mod.ts
customElements.define("cart-items", CartItems);
